module.exports = __webpack_public_path__ + "img/frb8s.584be667.jpg";